__turbopack_context__.v({
  "circle": "ImageUpload-module__EmOHpq__circle",
  "hiddenInput": "ImageUpload-module__EmOHpq__hiddenInput",
  "preview": "ImageUpload-module__EmOHpq__preview",
  "rectangle": "ImageUpload-module__EmOHpq__rectangle",
  "row": "ImageUpload-module__EmOHpq__row",
});
